//// Application Configuration

//// Application Packages
import React, { useState, useEffect } from 'react'
import { minutesToMilliseconds } from '../../functions/math-functions'
import { useIdleTimer } from 'react-idle-timer/legacy'

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

//////// Component
const ActivityTimerComponent = ({ handleLogout }) => {
    //////// Hooks

    //////// State

    // React Idle Timer
    const [reactIdleTimerState, setReactIdleTimerState] = useState('Active')
    const [reactIdleTimerCount, setReactIdleTimerCount] = useState(0)
    const [reactIdleTimerRemaining, setReactIdleTimerRemaining] = useState(0)

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    const onLogout = () => {
        handleLogout()
    }

    // React Idle Timer (onIdle)
    const onIdle = () => {
        setReactIdleTimerState('Idle')
        console.info('Account Idle: Beginning Logout Process')

        onLogout()

        console.log('Account Idle: Logout Process Complete')
        if (reactIdleTimerState) {
            return reactIdleTimerState
        } else {
            return null
        }
    }

    // React Idle Timer (onActive)
    const onActive = () => {
        setReactIdleTimerState('Active')
        if (reactIdleTimerState) {
            return reactIdleTimerState
        } else {
            return null
        }
    }

    // React Idle Timer (onAction)
    const onAction = () => {
        setReactIdleTimerCount(reactIdleTimerCount + 1)
        if (reactIdleTimerRemaining) {
            return reactIdleTimerRemaining
        } else {
            return null
        }
    }

    //////// Functional Methods

    // React Idle Timer
    const { getRemainingTime } = useIdleTimer({
        onIdle,
        onActive,
        onAction,
        timeout: minutesToMilliseconds(
            process.env.REACT_APP_SESSION_MAX_MINUTES
        ),
        throttle: 500,
    })

    //////// Memoization

    //////// Effects/Side Effects

    // React Idle Timer (System)
    useEffect(() => {
        const reactSessionInterval = setInterval(() => {
            setReactIdleTimerRemaining(Math.ceil(getRemainingTime() / 1000))
        }, 500)
        return () => clearInterval(reactSessionInterval)
    })

    //////////////// Debug

    //////////////// Render & Return
    return <></>
}

export default ActivityTimerComponent
